import { ExportTableRequest, ExportScenarioViewRequest } from "object-models/ExportPackModel";
import apiHandler from "../apiHandler";

export const _exportProjectRegister = async (request: ExportTableRequest): Promise<Blob> => {
  return apiHandler.post<Blob, ExportTableRequest>("export/project-register", request, 'blob');
};

export const _exportScenarioView = async (request: ExportScenarioViewRequest): Promise<Blob> => {
  return apiHandler.post<Blob, ExportScenarioViewRequest>("export/scenario-view", request, 'blob');
};

export const _exportInputDataPack = async (locationId: number): Promise<Blob> => {
  return apiHandler.get<Blob>(`export/input-data/${locationId}`, 'blob');
};
